// @flow
import styled from '@emotion/styled';

export const AccountPage = styled.div`
  background-color: ${props => props.theme.COLORS.GRAY_10};
`;
